import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Row, Col } from 'react-bootstrap'
import { CustomDataTable } from '../components/CustomDataTable';
import { LoadingBox } from '../components/LoadingBox';
import { ToolBar } from '../components/ToolBar'
import Swal from 'sweetalert2';
import { getNotificationsUser } from '../actions/notificationActions';
import { favouriteMessage, getMessagesUser, readMessage, removeMessage, responseMessage } from '../actions/messageActions';

import removeAccents from '../utils/removeAccents';
import { Editor } from 'react-draft-wysiwyg'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { EditorState, ContentState, convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'
import { changeMenu } from '../actions/navigationActions';

export const MessageScreen = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const messages = useSelector((state) => state.messageList)

    const { userInfo } = useSelector(state => state.userSignin)
    const [inbox, setInbox] = useState(true)
    const [messagesIn, setMessagesIn] = useState([])
    const [messagesOut, setMessagesOut] = useState([])

    const [sendingMessage, setsendingMessage] = useState(false)
    const [message, setMessage] = useState('')
    const [editorState, setEditorState] = useState(EditorState.createEmpty())

    const [lastestMessages, setLastestMessages] = useState('')
    const [messagesResume, setMessagesResume] = useState(null)
    const [messagesShow, setMessagesShow] = useState(null)


    const pushMessageHandler = async(e) => {
        e.preventDefault();
        if (message !== '') {
            setsendingMessage(true)
            if(messagesShow.sender._id === userInfo._id){
                dispatch(responseMessage({
                    idmessage: messagesShow.parent,
                    sender: messagesShow.receiver._id,
                    receiver: messagesShow.sender._id,
                    message: message
                }))
            }else{
                dispatch(responseMessage({
                    idmessage: messagesShow.parent,
                    sender: messagesShow.sender._id,
                    receiver: messagesShow.receiver._id,
                    message: message
                }))
            }
            setsendingMessage(false)
            Swal.fire({
                position: 'center',
                iconHtml: '<img src="/success.svg" class="mt-5">',
                html: '<p class="mb-7 mt-10 fw-bolder fs-2">Mensaje enviado</p><p class="mb-5">Hemos enviado el mensaje a sus destinatarios de forma correcta.</p><p class="fw-bolder">¿Qué quieres hacer ahora?</p>',
                showConfirmButton: true,
                showDenyButton: true,
                denyButtonText: `<button type="button" class="btn btn-info-outline text-info rounded-pill mt-0"><img src="/store.svg" alt="Tienda" class="me-2">Ir a tienda</button>`,
                denyButtonColor: "white",
                confirmButtonText: `<button type="button" class="btn btn-light-red-outline text-light-red rounded-pill mt-0"><img src="/school.svg" alt="Tienda" class="me-2">Ir a colegio</button>`,
                confirmButtonColor: "white",
                customClass: "invisible-buttons"
            }).then(result => {
                if (result.isConfirmed) {
                    dispatch(changeMenu("school"))
                    navigate('/')
                }
                if (result.isDenied) {
                    dispatch(changeMenu("store"))
                    navigate('/')
                }
            })
        }
        setMessage('');
        setEditorState(EditorState.createEmpty())
    }

    const setMessagesFavourite = async(message) => {
        dispatch(favouriteMessage(message))
    }

    const deleteMessage = async(message) => {
        
        Swal.fire({
            title: '¿Está seguro de eliminar este mensaje?',
            showDenyButton: true,
            confirmButtonText: 'Eliminar',
            denyButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeMessage(message))
                Swal.fire('Eliminado correctamente', '', 'success')
            }
        })
    }

    const handleEditorStateChange = (editorState) => {
        setEditorState(editorState)

        setMessage(draftToHtml(convertToRaw(editorState.getCurrentContent())))
    }

    useEffect(() => {
        dispatch(getMessagesUser(userInfo._id))
        dispatch(getNotificationsUser())
    }, [dispatch, navigate])

    useEffect(() => {
        if(messages){
            let arrayMessagesIn = []
            let arrayMessagesOut = []

            messages.messagesIn?.map((messages) => {
                arrayMessagesIn.push(messages)
            })
            setMessagesIn(arrayMessagesIn)

            messages.messagesOut?.map((messages) => {
                arrayMessagesOut.push(messages)
            })
            setMessagesOut(arrayMessagesOut)
        }
    }, [messages])

    useEffect(() => {
        if(messagesResume){
            let messagesStructure = '</br>'
            if(messagesResume.type === 'inbox'){
                let messageToShow = messagesIn.find(messageIn => messageIn._id === messagesResume._id)
                if(messageToShow?._id !== messagesShow?._id){
                    setMessagesShow(messageToShow)
                    dispatch(readMessage(messagesResume._id))

                    let timeToSave = 0

                    if(messageToShow?.messages){
                        for (let messageNow of messageToShow?.messages) {
                            if(messageNow._id === messagesResume._id){
                                timeToSave = 1
                            }
                            if(timeToSave === 1 && (messageNow.sender._id !== userInfo._id || messageNow.sender._id === userInfo._id && messageNow.sender_delete === false) && (messageNow.receiver._id !== userInfo._id || messageNow.receiver._id === userInfo._id && messageNow.receiver_delete === false)){
                                messagesStructure += '<hr style="border-style: dashed"/>'+
                                messageNow.message+'</br>'+
                                '<p>'+messageNow.sender.name+' - '+new Date(messageNow.date)?.toTimeString().substring(0, 5)+'    '+messageNow.date?.substr(8,2)+'/'+messageNow.date?.substr(5,2)+'/'+messageNow.date?.substr(0,4)+'</p>'
                            }
                        }
                    }
                    setLastestMessages(messagesStructure)
                }else{
                    setMessagesShow(null)
                    setLastestMessages('')
                }
            }else{
                let messageToShow = messagesOut.find(messageOut => messageOut._id === messagesResume._id)
                if(messageToShow !== messagesShow){
                    setMessagesShow(messageToShow)

                    let timeToSave = 0

                    if(messageToShow?.messages){
                        for (let messageNow of messageToShow?.messages) {
                            if(messageNow._id === messagesResume._id){
                                timeToSave = 1
                            }
                            if(timeToSave === 1 && (messageNow.sender._id !== userInfo._id || messageNow.sender._id === userInfo._id && messageNow.sender_delete === false) && (messageNow.receiver._id !== userInfo._id || messageNow.receiver._id === userInfo._id && messageNow.receiver_delete === false)){
                                messagesStructure += '<hr style="border-style: dashed"/>'+
                                messageNow.message+'</br>'+
                                '<p>'+messageNow.sender.name+' - '+new Date(messageNow.date)?.toTimeString().substring(0, 5)+'    '+messageNow.date?.substr(8,2)+'/'+messageNow.date?.substr(5,2)+'/'+messageNow.date?.substr(0,4)+'</p>'
                            }
                        }
                    }
                    setLastestMessages(messagesStructure)
                }else{
                    setMessagesShow(null)
                    setLastestMessages('')
                }
            }
        }
    }, [messagesResume])

    useEffect(() => {
        setMessagesShow(null)
    }, [inbox])

    const columnsIn = [
        {
            name: 'Favorito',
            cell: row =>
                <div className="d-flex align-items-center" onClick={() => setMessagesFavourite(row._id)}>
                    {(row.receiver._id === userInfo._id && row.receiver_fav)
                        ?
                            <><i className="fas fa-star text-warning"/></>
                        :
                            <><i className="far fa-star"/></>
                    }
                </div>,
            selector: (row) => row.receiver_fav,
            sortable: true,
        },
        {
            name: "Asunto",
            cell: row => 
                <div className="d-flex align-items-center" onClick={() => setMessagesResume({type: 'inbox', _id: row._id})}>
                    {inbox === true && row.viewed === false
                        ? <h2>{row.subject}</h2>
                        : row.subject
                    }
                </div>,
            selector: (row) => removeAccents(row.subject),
            sortable: true,
        },
        {
            name: 'Remitente',
            cell: row =>
                <div className="d-flex align-items-center" onClick={() => setMessagesResume({type: 'inbox', _id: row._id})}>
                    {row.sender.image
                        ?
                            <img className="h-40px w-40px rounded mx-3" src={row.sender.image}></img>
                        :
                            <img className="h-40px w-40px rounded mx-3" src="/assets/media/avatars/blank.png" alt="Avatar" />
                    }
                    {row.sender.name}
                </div>,
            selector: (row) => removeAccents(row.sender.name),
            sortable: true,
        },
        {
            name: 'Fecha',
            cell: row =>
                <div className="d-flex align-items-center" onClick={() => setMessagesResume({type: 'inbox', _id: row._id})}>
                    {new Date(row.date)?.toTimeString().substring(0, 5)+' ('+row.date?.substr(8,2)+'/'+row.date?.substr(5,2)+'/'+row.date?.substr(0,4)+')'}
                </div>,
            selector: (row) => row.date,
            sortable: true,
        },
        {
            name: 'Eliminar',
            cell: row =>
                <i className="fas fa-trash-alt" onClick={() => deleteMessage(row._id)} data-bs-toggle="tooltip" data-bs-placement="top" title="Eliminar"></i>,
            selector: (row) => row.date,
            sortable: false,
        }
    ]

    const columnsOut = [
        {
            name: 'Favorito',
            cell: row =>
                <div className="d-flex align-items-center" onClick={() => setMessagesFavourite(row._id)}>
                    {(row.sender._id === userInfo._id && row.sender_fav)
                        ?
                            <><i className="fas fa-star text-warning"/></>
                        :
                            <><i className="far fa-star"/></>
                    }
                </div>,
            selector: (row) => removeAccents(row.name),
            sortable: true,
        },
        {
            name: "Asunto",
            cell: row => 
                <div className="d-flex align-items-center" onClick={() => setMessagesResume({type: 'outbox', _id: row._id})}>
                    {row.subject}
                </div>,
            selector: (row) => removeAccents(row.subject),
            sortable: true,
        },
        {
            name: 'Destinatario',
            cell: row =>
                <div className="d-flex align-items-center" onClick={() => setMessagesResume({type: 'outbox', _id: row._id})}>
                    {row.receiver.image
                        ?
                            <img className="h-40px w-40px rounded mx-3" src={row.receiver.image}></img>
                        :
                            <img className="h-40px w-40px rounded mx-3" src="/assets/media/avatars/blank.png" alt="Avatar" />
                    }
                    {row.receiver.name}
                </div>,
            selector: (row) => removeAccents(row.receiver.name),
            sortable: true,
        },
        {
            name: 'Fecha',
            cell: row =>
                <div className="d-flex align-items-center" onClick={() => setMessagesResume({type: 'outbox', _id: row._id})}>
                    {new Date(row.date)?.toTimeString().substring(0, 5)+' ('+row.date?.substr(8,2)+'/'+row.date?.substr(5,2)+'/'+row.date?.substr(0,4)+')'}
                </div>,
            selector: (row) => removeAccents(row.name),
            sortable: true,
        },
        {
            name: 'Eliminar',
            cell: row =>
                <i className="fas fa-trash-alt" onClick={() => deleteMessage(row._id)}></i>,
            selector: (row) => row.date,
            sortable: false,
        }
    ]

    return (
        <>
            <ToolBar titulo={"Mensajería"} hitos={[
                { titulo: "Inicio", enlace: "/" },
                { titulo: "Mensajería", enlace: "#" },
            ]} />
            <div id="kt_content_container" className="d-flex flex-column-fluid align-items-start container-xxl">
                <form autoComplete='off' className="form w-100" noValidate="novalidate" id="kt_sign_in_form" onSubmit={pushMessageHandler}>
                    <div className="content flex-row-fluid" id="kt_content">
                        <div className="card card-flush">
                            <div className="card-header py-10">
                                <div className='col-12 col-md-10 text-start mb-10'>
                                    <h2 className="text-primary fs-1 mb-1">Listado de mensajes</h2>
                                    <div className='separator'/>
                                </div>
                            </div>
                            <div className="card-body pt-0">
                                <div className='row'>
                                    <div className='col-12 col-md-4 border-md-end'>
                                        <div className='d-none d-md-block'>
                                            <div className='d-grid mb-4'>
                                                <button type='button' className={`btn rounded-pill btn-white btn-active ${inbox ? 'selected' : ''}`} onClick={() => setInbox(true)}>Bandeja de entrada</button>
                                            </div>
                                            <div className='d-grid'>
                                                <button type='button' className={`btn rounded-pill btn-white btn-active ${inbox ? '' : 'selected'}`} onClick={() => setInbox(false)}>Bandeja de salida</button>
                                            </div>
                                        </div>
                                        <div className='d-block d-md-none'>
                                            <ul className='nav nav-tabs nav-line-tabs pb-5 mb-10'>
                                                <li className='nav-item'>
                                                    <button type='button' className={`btn rounded-pill btn-white btn-active ${inbox ? 'selected' : ''}`} onClick={() => setInbox(true)}>Bandeja de entrada</button>
                                                </li>
                                                <li className='nav-item'>
                                                    <button type='button' className={`btn rounded-pill btn-white btn-active ${inbox ? '' : 'selected'}`} onClick={() => setInbox(false)}>Bandeja de salida</button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-8'>
                                        {inbox
                                            ?
                                                <CustomDataTable pagination data={messagesIn} columns={columnsIn} onRowClicked={(row) => setMessagesResume({type: 'inbox', _id: row._id})}/>
                                            :
                                                <CustomDataTable pagination data={messagesOut} columns={columnsOut} onRowClicked={(row) => setMessagesResume({type: 'outbox', _id: row._id})}/>
                                        }
                                        {messagesShow
                                            ?
                                                <>
                                                <hr/>
                                                    <Row>
                                                        <Col className="text-start">
                                                            {messagesShow.sender._id === userInfo._id
                                                                ?
                                                                messagesShow.receiver.image
                                                                    ?
                                                                        <img className="h-40px w-40px rounded mx-3" src={messagesShow.receiver.image}></img>
                                                                    :
                                                                        <img className="h-40px w-40px rounded mx-3" src="/assets/media/avatars/blank.png" alt="Avatar" />
                                                                :
                                                                messagesShow.sender.image
                                                                    ?
                                                                        <img className="h-40px w-40px rounded mx-3" src={messagesShow.sender.image}></img>
                                                                    :
                                                                        <img className="h-40px w-40px rounded mx-3" src="/assets/media/avatars/blank.png" alt="Avatar" />
                                                            }
                                                            <b>{messagesShow.sender.name}</b>
                                                        </Col>
                                                        <Col className="text-center"><h3>Asunto:</h3> {messagesShow.subject}</Col>
                                                        <Col className="text-end">
                                                            <h3>Hora - Fecha:</h3> {new Date(messagesShow.date)?.toTimeString().substring(0, 5)+'  -  '+messagesShow.date?.substr(8,2)+'/'+messagesShow.date?.substr(5,2)+'/'+messagesShow.date?.substr(0,4)}</Col>   
                                                    </Row>
                                                    {inbox
                                                        ?
                                                            <>
                                                                <div className='row border-top mt-5 pt-5'>
                                                                    <div className='col-12 col-md-6 offset-md-6'>
                                                                        <div className='d-grid'>
                                                                            <button type="submit" id="kt_sign_in_submit" className="btn rounded-pill btn-lg btn-primary">     
                                                                                {sendingMessage ? (<LoadingBox variant={"primary"}/>)
                                                                                :
                                                                                (<span className="indicator-label">Responder</span>)}
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='my-5'>
                                                                    <Editor
                                                                        toolbar={{
                                                                            options: ['inline', 'list', 'textAlign', 'link'],
                                                                            inline: { options: ['bold', 'italic', 'underline'] },
                                                                            list: { options: ['unordered', 'ordered'] },
                                                                            textAlign: { options: ['left', 'center', 'right'] },
                                                                            link: { options: ['link', 'unlink'] }
                                                                        }}
                                                                        editorState={editorState}
                                                                        onEditorStateChange={handleEditorStateChange}
                                                                    />
                                                                </div>
                                                            </>
                                                        :
                                                            <></>
                                                    }
                                                    <Row>
                                                        <Col className="text-start p-4">
                                                            <p dangerouslySetInnerHTML={{__html: lastestMessages}}></p>
                                                        </Col>
                                                    </Row>
                                                </>
                                            :
                                                <></>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    )
}
